import React from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import LinkButton from '@/components/LinkButton';
import { useTranslation } from '@/hooks/translation';
import LoginModal from '@separate/components/LoginModal';
import { CHECKOUT_STARTED, PODERSALUD_PRODUCT_ID } from '@separate/constants/analytics';
import { logEvent } from '@separate/utilities/analytics';

export default function SignUpButton(props) {
  const { loading, isLoggedIn, isPremiumMember, className, couponText } = props;

  const [showLogin, setShowLogin] = React.useState(false);

  const { push } = useRouter();

  const { t } = useTranslation();

  const queryText = couponText ? `?couponText=${couponText}` : '';

  const premiumLink = isLoggedIn ? `/premium/enrollment${queryText}` : '/premium/';

  function startEnrollment() {
    push(`/premium/enrollment${queryText}`);
  }

  function handleLoginSuccess() {
    startEnrollment();
  }

  function handleClick() {
    logEvent(CHECKOUT_STARTED, { product_id: PODERSALUD_PRODUCT_ID });

    if (isLoggedIn) {
      startEnrollment();
    } else {
      setShowLogin(true);
    }
  }

  return (
    <>
      <LinkButton
        href={premiumLink}
        loading={loading}
        disabled={isPremiumMember}
        onClick={handleClick}
        className={className}
      >
        {isPremiumMember ? t('premium.already_enrolled') : t('premium.signup')}
      </LinkButton>
      <LoginModal
        show={showLogin}
        onHide={() => setShowLogin(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  );
}

SignUpButton.propTypes = {
  loading: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isPremiumMember: PropTypes.bool,
  className: PropTypes.string,
  couponText: PropTypes.any
};
